/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdmissionsBoardSource
 */
export interface AdmissionsBoardSource {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    name: string;
    /**
     * Source type, e.g. Hospital or Skilled Nursing Facility.
     */
    type: string | null;
}

/**
 * Check if a given object implements the AdmissionsBoardSource interface.
 */
export function instanceOfAdmissionsBoardSource(value: object): value is AdmissionsBoardSource {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function AdmissionsBoardSourceFromJSON(json: any): AdmissionsBoardSource {
    return AdmissionsBoardSourceFromJSONTyped(json, false);
}

export function AdmissionsBoardSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdmissionsBoardSource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'type': json['type'],
    };
}

export function AdmissionsBoardSourceToJSON(json: any): AdmissionsBoardSource {
    return AdmissionsBoardSourceToJSONTyped(json, false);
}

export function AdmissionsBoardSourceToJSONTyped(value?: AdmissionsBoardSource | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'type': value['type'],
    };
}

